/**
 * The words of HR's working time and the employment record, closed together (#72 work schedules,
 * #38 attendance, #33 employees): kept beside the catalogue, as the hubs' and views' words are, and
 * spread into it.
 */
export const HR_TIME_EN = {
    // ── #72 — swaps ─────────────────────────────────────────────────────────────────────────────
    'value.kind.handover': 'Handover',
    'value.kind.exchange': 'Exchange',
    'value.status.requested': 'Requested',
    // ── #72 — the policy and announced Ramadan ─────────────────────────────────────────────────
    'value.status.in_use': 'In force',
    // ── #33 employees — sponsorship, a transfer's consent, the fixed-term review, the statute rows ──
    'value.type.sponsorship_transfer': 'Sponsorship transfer',
    'value.review_reason.renewals': 'Renewed three times',
    'value.review_reason.years': 'Four years reached',
};
export const HR_TIME_AR = {
    'value.kind.handover': 'تسليم',
    'value.kind.exchange': 'مبادلة',
    'value.status.requested': 'مطلوب',
    'value.status.in_use': 'سارٍ',
    // ── #33 employees — sponsorship, a transfer's consent, the fixed-term review, the statute rows ──
    'value.type.sponsorship_transfer': 'نقل خدمات',
    'value.review_reason.renewals': 'جُدّد ثلاث مرّات',
    'value.review_reason.years': 'بلغ أربع سنوات',
};
//# sourceMappingURL=i18n-hr-time.js.map